import { connect } from 'react-redux';

import {
  fbLoginStart,
  googleLoginStart,
  logoutStart,
  hideLoginModal,
  hideMergeModal,
  mergeAccountStart,
  hideLogoutConfirmationModal,
  hideGeneratePasswordModal
} from 'store/login/login.actions';
import { showSnackbarNotification } from 'store/notification/notification.actions';

const mapStateToProps = (state) => ({
  loginState: state.login,
  userState: state.user
});

const mapDispatchToProps = (dispatch) => ({
  onFbLoginStart: () => dispatch(fbLoginStart()),
  onGoogleLoginStart: () => dispatch(googleLoginStart()),
  onLogoutStart: () => dispatch(logoutStart()),
  onHideLoginModal: () => dispatch(hideLoginModal()),
  onHideGeneratePasswordModal: () => dispatch(hideGeneratePasswordModal()),
  onHideMergeModal: () => dispatch(hideMergeModal()),
  onMergeAccounts: () => dispatch(mergeAccountStart()),
  onHideLogoutConfirmationModal: () => dispatch(hideLogoutConfirmationModal()),
  onShowSnackbarNotification: (message) =>
    dispatch(showSnackbarNotification(message))
});

const container = connect(mapStateToProps, mapDispatchToProps);

export default container;
